export default __webpack_public_path__ + "aaad175cc9170b26018e4953cdd970f7.jpg";